import { SelectItem } from 'primeng/primeng';

export interface IRemittanceStageColumn {
  field: string,
  header: string,
  editable: boolean,
  style: any,
  sort: boolean,
  exportable: boolean,
  hidden: boolean,
  resizable: boolean,
}
export class RemittanceStageTableHelper {
  public StagedRemittanceColumns: IRemittanceStageColumn[];
  public StagedRemittanceColumnSelections: SelectItem[];

  constructor() {
    this.generateStagedRemittanceColumns();
    this.StagedRemittanceColumnSelections = this.generateSelections(this.StagedRemittanceColumns)
  }

  generateSelections(columns: IRemittanceStageColumn[]): SelectItem[] {
    if (!columns) {
      return null
    }
    let options = []
    for (let col of columns) {
        options.push({label: col.header, style: col.style, value: col });
    }
    return options
}

  generateStagedRemittanceColumns(): void {
    this.StagedRemittanceColumns = [
      { field: 'edit', header: '', editable: false, style: { width: '30px' }, sort: false, exportable: false, hidden: false, resizable: false },
      { field: 'delete', header: '', editable: false, style: { width: '30px' }, sort: false, exportable: false, hidden: false, resizable: false },
      { field: 'StoreId', header: 'Store', editable: false, style: { width: '60px' }, sort: true, exportable: true, hidden: false, resizable: true },
      { field: 'Prescription_PrescriptionNumber', header: 'Rx Number', editable: false, style: { width: '70px' }, sort: true, exportable: true, hidden: false, resizable: true },
      { field: 'Prescription_FillDate', header: 'Fill Date', editable: false, style: { width: '70px' }, sort: true, exportable: true, hidden: false, resizable: true },
      { field: 'Money_PaidAmount', header: 'Paid Amount', editable: false, style: { width: '80px' }, sort: true, exportable: true, hidden: false, resizable: true },
      { field: 'Remittance_AdjustmentCodes', header: 'Adjustment Codes', editable: false, style: { width: '90px' }, sort: false, exportable: true, hidden: false, resizable: true },
      { field: 'Valid_Posted_Claim', header: 'Matched', editable: false, style: { width: '55px' }, sort: true, exportable: true, hidden: false, resizable: true },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/components/remittance-entry/remittance-stage/remittance-stage.tableHelper.ts